import { ReactElement } from 'react';
import { translate } from 'src/app/project/features/translate/translate';
import { EPriority } from 'src/app/project/modules/points/priorities';
import BulkOptionDialog, { TBulkOption } from './BulkOptionDialog';
import PriorityLabel, { OPTION_BY_PRIORITY } from './PriorityLabel';

type TBulkPriorityDialogProps = {
  onClose: () => void;
  onSave: (priority: EPriority) => Promise<void>;
};

const PRIORITY_ORDER: EPriority[] = [EPriority.HIGH, EPriority.MEDIUM, EPriority.LOW];

const OPTIONS: TBulkOption<EPriority>[] = PRIORITY_ORDER.map((priority) => ({
  value: priority,
  label: <PriorityLabel option={OPTION_BY_PRIORITY[priority]} />,
}));

const BulkPriorityDialog = ({ onClose, onSave }: TBulkPriorityDialogProps): ReactElement => (
  <BulkOptionDialog
    title={translate('change_priority')}
    sectionLabel={translate('priority')}
    options={OPTIONS}
    onClose={onClose}
    onSave={onSave}
  />
);

export default BulkPriorityDialog;
